import * as React from 'react';
import { Badge } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { InvoiceStatus } from '@wix/ambassador-wix-quotes-web/types';
import { isStatusDisplayed } from './status-utils';
const skinMapping = {
    Draft: 'neutral',
    Processing: 'standard',
    Sent: 'neutralStandard',
    PartiallyPaid: 'warning',
    PartialAndOverdue: 'warning',
    Paid: 'success',
    Overdue: 'danger',
    Void: 'neutralDanger',
};
const statusToSkin = (status) => skinMapping[status] || 'warning';
const Status = ({ status, isUoU = false, isOutlined = false, t, }) => {
    if (!isStatusDisplayed({ status, isUoU })) {
        return null;
    }
    const text = t(`invoice-view:quote.preview_status.${status.toLowerCase()}`);
    const skin = statusToSkin(status);
    const type = isOutlined ? 'outlined' : 'solid';
    return status === InvoiceStatus.PartialAndOverdue ? (React.createElement(PartialAndOverdue, { t: t, type: type })) : (React.createElement("div", { "data-hook": "status" },
        React.createElement(Badge, { dataHook: "status-badge", type: type, skin: skin, uppercase: false }, text)));
};
const PartialAndOverdue = ({ t, type }) => (React.createElement("div", { "data-hook": "status" },
    React.createElement(Badge, { dataHook: "partial-badge", type: type, skin: statusToSkin(InvoiceStatus.PartiallyPaid), uppercase: false }, t(`invoice-view:quote.preview_status.${InvoiceStatus.PartiallyPaid.toLowerCase()}`)),
    React.createElement(Badge, { dataHook: "overdue-badge", type: type, skin: statusToSkin(InvoiceStatus.Overdue), uppercase: false }, t(`invoice-view:quote.preview_status.${InvoiceStatus.Overdue.toLowerCase()}`))));
export default withTranslation(['invoice-view', 'locale-data'])(Status);
//# sourceMappingURL=Status.js.map